import React, {useState} from 'react';
import Modal from '../../components/modal/modal.jsx';
import ErrorMsg from "../../components/error-msg/error-msg";
import Button from "../../components/button/button";
import Message from "../../components/message/message";
import Input from "../../components/forms/input/input";

const ClazzCodeFormModal = ({onSubmit, onClose}) => {
    const [clazzCode, setClazzCode] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    return (
        <Modal
            onClose={onClose}
            title={window.L("teach.clazz.code")}
            tips={window.L("teach.course.pleaseInputClassCode")}
            >
            <ErrorMsg errorMsg={errorMsg} />
            <Input
                placeholder={window.L("teach.clazz.code")}
                onChange={setClazzCode}
                />
            <div style={{textAlign: 'center'}}>
                <Button
                    theme={"submit"}
                    label="提交"
                    onClick={async () => {
                        if (clazzCode) {
                            if (onSubmit) onSubmit(clazzCode);
                        }else {
                            Message.show(window.L("teach.course.classCodeIsRequired"));
                        }
                    }}
                    />
            </div>
        </Modal>
    )
}

export default ClazzCodeFormModal;
